<div class="app flex-row align-items-center">
  
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-md-6 ra-content-center">

        <div class="text-center">
          <img src="../../../assets/img/lost.png" width="350px">
          <br><br>
          <h1 style="margin-bottom:5px"><b>La page que vous cherchez semble introuvable !</b></h1>
          <span class="text-muted">Vous devez vous connecter pour pouvoir accéder à cette page.</span>
          <br><br><br>
        </div>
        
        <div class="ra-button ra-button-primary" routerLink="/">Retouner à la page d'accueil</div>
      </div>
    </div>
  </div>
</div>